<template>
    <v-card>
        <v-card-title>
            <h2 v-if="user.role === 'admin' || user.role === 'builder' && mode === 'all'">
                All Sites
            </h2>
            <h2 v-else>
                Completed Sites
            </h2>
            <v-spacer v-if="user.role === 'admin' || user.role === 'builder'" />
            <v-text-field
                v-model="search"
                append-icon="fas fa-search"
                label="Search Sites"
                single-line
                hide-details
                outlined
                dense
            />
            <v-btn
                small
                icon
                @click="getSites"
            >
                <v-icon small>
                    fas fa-sync
                </v-icon>
            </v-btn>
        </v-card-title>
        <v-card-text>
            <v-radio-group
                row
                dense
                v-model="mode"
                @change="getSites"
            >
                <v-radio
                    value="all"
                    label="All Sites"
                />
                <v-radio
                    value="complete"
                    label="Completed Sites"
                />
                <v-radio
                    value="incomplete"
                    label="Incomplete Sites"
                />
            </v-radio-group>
            <v-data-table
                :headers="headers"
                :items="userInfo"
                :items-per-page="10"
                :search="search"
                :loading="tableLoading"
            >
                <template #item.site_completion="{ item }">
                    <v-icon
                        v-if="item.site_completion"
                        small
                        color="primary"
                    >
                        fas fa-check-circle
                    </v-icon>
                    <span v-else>{{ completionPercentage(item.card_completions) }} </span>
                </template>
                <template #item.id="{ item }">
                    <v-btn
                        icon
                        small
                        :to="'/site/single/' + item.id"
                    >
                        <v-icon
                            color="primary"
                            small
                        >
                            fas fa-file
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.name="{ item }">
                    <router-link
                        v-if="user.role === 'admin'"
                        :to="'/user/edit/' + item.id"
                    >
                        {{ item.name }}
                    </router-link>
                    <span v-else>{{ item.name }}</span>
                </template>
                <template #item.profession="{ item }">
                    <span v-if="item.profession">
                        {{ item.profession.name }}
                    </span>
                    <span v-else>No Specialty</span>
                </template>
                <template #item.admin_note="{ item }">
                    <v-btn
                        v-if="item.admin_note"
                        icon
                        small
                        @click="showNote(item.admin_note)"
                    >
                        <v-icon
                            small
                            color="primary"
                        >
                            fas fa-sticky-note
                        </v-icon>
                    </v-btn>
                </template>
                <template #item.roles="{ item }">
                    {{ item.roles[0].name }}
                </template>
                <template #item.email="{ item }">
                    <v-btn
                        icon
                        small
                        @click="download(item.id, item.name)"
                    >
                        <v-icon small>
                            fas fa-download
                        </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </v-card-text>
        <v-dialog
            max-width="500"
            v-model="noteDialog"
        >
            <v-card>
                <v-card-title>
                    Note
                </v-card-title>
                <v-card-text>{{ note }}</v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        color="primary"
                        @click="closeNoteDialog"
                    >
                        Close
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import axios from 'axios';
import formatDate from '@/helpers/formatDate';
import { mapState } from 'vuex';
import exportProject from '@/helpers/exportProject';

export default {
    computed: {
        ...mapState('auth', ['user'])
    },

    data() {
        return {
            noteDialog: false,
            note: undefined,
            error: '',
            search: '',
            userInfo: [],
            mode: 'all',
            tableLoading: true,
            totalDataCollectionCards: 0,
            headers: [
                {
                    text: 'Complete',
                    value: 'site_completion',
                    width: '110px'
                },
                {
                    text: 'Report',
                    value: 'id',
                    width: '100px'
                },
                {
                    text: 'User',
                    value: 'name',
                    width: '225px'
                },
                {
                    text: 'Role',
                    value: 'roles',
                    width: '100px'
                },
                {
                    text: 'Specialty',
                    value: 'profession',
                    width: '125px'
                },
                {
                    text: 'Note',
                    value: 'admin_note',
                    width: '85px'
                },
                {
                    // This is hacky. I need another column for ID, but ID is in use.
                    // Email isn't used in this table, so I'm using that for the column.
                    text: 'Export',
                    value: 'email',
                    align: 'right',
                    sortable: false,
                    filterable: false
                }
            ]
        };
    },

    mounted() {
        this.getAllSites();
    },

    methods: {
        getSites() {
            this.getAllSites();
        },

        getAllSites() {
            this.tableLoading = true;
            axios
                .get(`/api/report/site/${this.mode}`)
                .then((response) => {
                    this.totalDataCollectionCards = response.data.numCards;
                    this.userInfo = response.data.users;
                    this.tableLoading = false;
                })
                .catch((error) => {
                    this.error = error;
                    this.tableLoading = false;
                });
        },

        displayDate(date) {
            return formatDate(date);
        },

        download(id, userName) {
            exportProject(id, userName);
        },

        showNote(note) {
            this.note = note;
            this.noteDialog = true;
        },

        closeNoteDialog() {
            this.note = undefined;
            this.noteDialog = false;
        },

        round(value) {
            return Math.ceil(value);
        },

        completionPercentage($completeCards) {
            if ($completeCards) {
                console.log(this.totalDataCollectionCards);
                return this.round(($completeCards.length / this.totalDataCollectionCards) * 100) + '%';
            }

            return '';
        }
    }
};
</script>
